module.exports = __webpack_public_path__ + "static/media/400408_01.f79e85e1.png";